module.exports = __webpack_public_path__ + "static/media/spinner.99d1aaf7.svg";